import './App.css';
import {BrowserRouter as Router , Routes , Route} from "react-router-dom"
import { ColorScheme, ColorSchemeProvider , MantineProvider , Paper} from "@mantine/core"
import { useLocalStorage , useHotkeys} from '@mantine/hooks';
import HomePage from './Pages/Home';
import ARGPage from './Pages/ARG';
import SKJPage from './Pages/SKJ';
import ProductPage from './Pages/Product';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermCondition from './Pages/TermAndCondition';


function App() {

  const [colorScheme , setColorScheme] = useLocalStorage<ColorScheme>({
    key:'mantine-color-scheme',
    defaultValue: 'light'
  });

  const toggleColorScheme = (value?: ColorScheme) =>{
    setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));
  }

  useHotkeys([['mod+J' , ()=> toggleColorScheme()]]);

  return (
    <div className="App">
      <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
      <MantineProvider theme={{colorScheme}}>
        <Paper p="md" radius={0} style={{minHeight: "100vh"}}>
          <Router>
            <Routes>
              <Route path='/' element={<HomePage/>}/>
              <Route path='/ayushraj' element={<ARGPage/>}/>
              <Route path='/sushant' element={<SKJPage/>}/>
              <Route path = '/product' element={<ProductPage/>}/>
              <Route path = '/privacy_policy' element={<PrivacyPolicy/>}/>
              <Route path = '/terms_and_conditions' element={<TermCondition/>}/>
            </Routes>
          </Router>
        </Paper>
      </MantineProvider>
      </ColorSchemeProvider>
    </div>
  );
}

export default App;
